module.exports = __webpack_public_path__ + "img/learn_nagasaki_white.74d3553b.png";